import { createContext } from '@lit/context';

// Tracks the delivery method chosen on the applicant-information form (e.g. 'pabol' | 'email' | '').
// Used to make SOURCE.EMBEDDED_AGENT act like SOURCE.EMAIL when the agent chooses to email the client.
export const deliveryMethodContext = createContext<string>(Symbol('deliveryMethod'));
